import { Component} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'refactor-pages-main',
  standalone: false,
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss'
})
export class MainComponent {

  constructor(private router: Router) {}

  goToUploadFiles() {
    this.router.navigate(['/coding/refactor/upload-files']); 
  }
}
